export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-16 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/50"></div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full space-y-6 animate-fade-in-up">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary-100/70 rounded-full">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              <span className="text-xs font-medium text-primary-700 whitespace-nowrap">每日更新 · 一手爆料</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
              黑料网站
              <span className="block text-primary-500">全网最新黑料资讯聚合平台</span>
            </h1>

            <p className="font-heading text-lg md:text-xl text-primary-600 font-medium">
              深挖内幕，揭露真相，掌握一手爆料资讯
            </p>

            <p className="text-foreground-700 leading-relaxed max-w-xl">
              黑料网站是国内领先的社会热点事件深度报道与内幕资讯聚合平台，汇聚娱乐圈八卦、互联网企业内幕、直播带货乱象、金融圈黑幕等多个领域的独家爆料。我们坚持真实、客观的报道原则，每日更新大量一手资讯，帮助用户快速掌握最新曝光动态。无论是关注黑料网站入口还是黑料网最新网址，本站都是您值得信赖的信息来源。
            </p>

            <div className="flex flex-wrap items-center gap-6 pt-2">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100">
                  <i className="ri-article-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-bold text-foreground-900">5,000+</div>
                  <div className="text-xs text-foreground-500">深度报道</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100">
                  <i className="ri-user-line text-primary-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-bold text-foreground-900">100万+</div>
                  <div className="text-xs text-foreground-500">日均访问用户</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100">
                  <i className="ri-shield-check-line text-secondary-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-bold text-foreground-900">15+</div>
                  <div className="text-xs text-foreground-500">内容频道覆盖</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 pt-2">
              <a
                href="#carousel"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                浏览焦点专题
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-background-300 text-foreground-700 font-medium text-sm rounded-lg hover:border-primary-300 hover:text-primary-600 hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                查看热门排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end animate-fade-in">
            <div className="relative w-full max-w-lg">
              <div className="absolute -inset-4 bg-primary-500/10 rounded-2xl blur-3xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20composition%20with%20layered%20abstract%20geometric%20shapes%20and%20news%20media%20elements%2C%20deep%20charcoal%20and%20warm%20crimson%20color%20palette%20with%20golden%20highlights%2C%20modern%20sophisticated%20newsroom%20aesthetic%2C%20professional%20journalism%20atmosphere%2C%20cinematic%20lighting%20with%20subtle%20gradients%2C%20high-end%20magazine%20layout%20style%2C%20clean%20minimalist%20background%20with%20dynamic%20diagonal%20lines%2C%20editorial%20design%20quality&width=1200&height=900&seq=hero-main&orientation=landscape"
                alt="黑料网站主视觉 - 新闻资讯聚合平台"
                className="relative w-full h-auto rounded-2xl object-cover shadow-lg"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  target.parentElement!.querySelector('.hero-fallback')?.classList.remove('hidden');
                }}
              />
              <div className="hero-fallback hidden absolute inset-0 rounded-2xl bg-background-200 flex items-center justify-center">
                <div className="text-center">
                  <i className="ri-image-line text-4xl text-foreground-400"></i>
                  <p className="mt-2 text-sm text-foreground-500">黑料网站 · 资讯聚合平台</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}